module.exports = __webpack_public_path__ + "img/step1.497f4d89.png";